import React, {Component, PropTypes} from 'react';

// Subviews
import Seat from './seat';

export default class SIMSvgRow extends Component {

  shouldComponentUpdate (nextProps) {
    var changed = {
      availableSeatCount: this.props.availableSeatCount !== nextProps.availableSeatCount,
      seats:              this.props.activeSeats !== nextProps.activeSeats
    };
    return changed.availableSeatCount || changed.seats;
  }

  render () {
    const {seats, activeSeats} = this.props;

    return (
      <g data-component="svg__row" className="row">
        {seats.map((seat) => <Seat {...seat} key={seat.id} activeSeats={activeSeats}/>)}
      </g>
    );
  }
}

SIMSvgRow.propTypes = {
  seats:       PropTypes.arrayOf(PropTypes.object).isRequired,
  activeSeats: PropTypes.arrayOf(PropTypes.string).isRequired
};



// WEBPACK FOOTER //
// ./frontend/react/sim/core/components/map/svg/row.jsx